import {GameConfig} from "../config/GameConfig";

export type Stats = {
    maxHealth: number;
    health: number;
    attack: number;
    speed: number;
    crit: number;
    gold: number;
};

export function computeCritAttack(stats: Stats): number {
    const critChance = stats.crit / 100;

    if (Math.random() < critChance) {
        return stats.attack * 2;
    }

    return stats.attack;
}

export function addStatsHealth(stats: Stats, health: number): void {
    stats.health = Math.min(stats.health + health, stats.maxHealth)
}